declare module '@df/core/df-core.config' {
    interface IDfConfig {
        grecaptcha?: {
            key?: string;
        };
    }
}

declare global {
    interface Window {
        grecaptcha?: GoogleRecaptcha.IApi;
    }
}

export namespace GoogleRecaptcha {
    export const API_CALLBACK = 'onGoogleRecaptchaReady';
    export const API_JS_URL = 'https://www.google.com/recaptcha/api.js';

    export interface IApi {
        ready(onReadyCallback: () => void);
        execute(siteKey: string, options: IApiExecuteOptions): Promise<string>;
    }

    export interface IApiOptions {
        onload?: string;
        render: string;
    }

    export interface IApiExecuteOptions {
        action: string;
    }

    export interface IOnReadyCallback {
        (token: string): void;
    }

    export interface IData {
        [key: string]: any;
        token?: string;
    }
}